import { render } from "./UEResearchEditView.vue?vue&type=template&id=84c006f8&scoped=true"
import script from "./UEResearchEditView.vue?vue&type=script&lang=js"
export * from "./UEResearchEditView.vue?vue&type=script&lang=js"

import "./UEResearchEditView.vue?vue&type=style&index=0&id=84c006f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c006f8"]])

export default __exports__